export const COOKIE_CONSENT_KEY = "cookieConsent";
export const ENVIRONMENT = import.meta.env
  .VITE_LIFELINE_CHAT_SURVEY_ENVIRONMENT;
export const DOMAIN =
  ENVIRONMENT === "production" ? ".988lifeline.org" : undefined;
